import publicCta from '../content/publicCta.json';
import { getWhatsAppUrl } from '../constants/whatsappContact.js';

/** URL de WhatsApp para solicitar información de una línea de crédito. */
export function getCreditoWhatsAppHref(credito) {
  const topic = publicCta.whatsappTopics?.find((t) => t.id === 'creditos');
  const base = topic?.message || 'Hola, quiero más información sobre créditos.';
  const titulo = String(credito?.titulo || 'línea de crédito').trim();
  const categoria = String(credito?.categoria || '').trim();
  const extra = categoria ? ` (${categoria})` : '';
  const message = `${base} Me interesa: ${titulo}${extra}.`;
  return getWhatsAppUrl(message);
}
